module.exports = __webpack_public_path__ + "static/media/concierge-bell.a129fc68.svg";